import { ResourceOptions } from 'react-admin';
import { FaChartBar } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingPoolContributions;
export const icon = FaChartBar;
export const options: ResourceOptions = {
  label: 'module.socialTrading.poolContributions',
};
